import { useState } from "react";
import {
  Typography,
  Form,
  Input,
  Row,
  Button,
  Col,
  message,
  Result,
  Space,
} from "antd";
import {
  MailOutlined,
  WhatsAppOutlined,
  GithubOutlined,
} from "@ant-design/icons";
import { sendMessage } from "../../../api/message.module";
import ReactHelmet from "../../../helpers/ReactHelmet";
const { Paragraph, Text } = Typography;
function Contact({ screenWidth }) {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const handleSubmit = async (v) => {
    setLoading(true);
    try {
      const dt = await sendMessage(v);
      message.success(dt.message);
      setSent(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
      message.error(error.response.message);
      setLoading(false);
    }
  };
  return (
    <Paragraph
      style={{
        // display: "flex",
        // flexDirection: "column",
        // justifyContent: "center",
        // textAlign: "center",
        padding: screenWidth < 800 ? "1rem" : "1vh 10vw",
      }}
    >
      <ReactHelmet title="Contact" />
      <Row>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Paragraph
            style={{
              fontSize: "1.5rem",
              margin: "0 0 2rem 0",
              textAlign: "center",
            }}
            strong
          >
            GET{" "}
            <Text style={{ color: "#0abacc", fontSize: "1.5rem" }}>
              IN TOUCH
            </Text>
          </Paragraph>

          <Paragraph style={{ fontSize: "16px" }}>
            You can reach out to me anytime. I'm always eager to explore new
            projects, collaborate on creative ideas, or contribute to bringing
            your visions to life.
            <Text style={{ color: "#0c6f8d", cursor: "pointer" }}> </Text>
          </Paragraph>
          <Space direction="vertical" size={15}>
            <Space>
              <MailOutlined style={{ fontSize: "2rem" }} />
              <Paragraph style={{ margin: 0 }}>
                <Text>Email</Text> <br />
                <Text style={{ color: "gray" }}>
                  muhumuzajamir2016@gmail.com
                </Text>
              </Paragraph>
            </Space>
            <Space>
              <WhatsAppOutlined style={{ fontSize: "2rem" }} />
              <Paragraph style={{ margin: 0 }}>
                <Text> WhatsApp</Text>
                <br />
                <Text style={{ color: "gray" }}> +256700697699</Text>
              </Paragraph>
            </Space>
            <Space>
              <GithubOutlined style={{ fontSize: "2rem" }} />
              <Paragraph style={{ margin: 0 }}>
                <Text>GitHub</Text>
                <br />
                <Text style={{ color: "gray" }}>
                  <a href="https://github.com/JamirGVTimes">JamirGVTimes </a>
                </Text>
              </Paragraph>
            </Space>
          </Space>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} style={{ paddingTop: "1rem" }}>
          {sent ? (
            <>
              <Paragraph>
                <Result
                  status="success"
                  title="Message Sent!!!"
                  subTitle="Thank you for getting in touch with Jamir; you can anticipate a response from him within the next 2 hours."
                />
              </Paragraph>
            </>
          ) : (
            <>
              <Form
                name="message-form"
                layout="vertical"
                onFinish={handleSubmit}
              >
                <Row gutter={12}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <Form.Item
                      label="Your Names"
                      name="name"
                      rules={[
                        { required: true, message: "Your name is required!" },
                      ]}
                    >
                      <Input placeholder="Your Names" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <Form.Item
                      label="Your Email address"
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "Please provide your email!",
                        },
                      ]}
                    >
                      <Input placeholder="Email Address" />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  label="Message"
                  name="message"
                  rules={[
                    { required: true, message: "Message can't be empty!" },
                  ]}
                >
                  <Input.TextArea placeholder="Enter your message" rows={5} />
                </Form.Item>
                <Paragraph style={{ textAlign: "right" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    block={screenWidth < 800}
                  >
                    Send Message
                  </Button>
                </Paragraph>
              </Form>
            </>
          )}
        </Col>
      </Row>
    </Paragraph>
  );
}

export default Contact;
